import styled from "styled-components";

import { SPACING } from "../../../../utils/constants";

export const UnavailableBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${SPACING.sm}px;
  font-size: var(--text-base);
`;
